import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { HiOutlineChevronDown, HiOutlineX, HiOutlineBookmark  } from "react-icons/hi";
import { motion, AnimatePresence } from "framer-motion";

const FormDropdown = ({
  options,
  onSelect,
  selectedOption,
  index,
  property,
  clearSelect,
  clearServiceOption,
  type,
  userPrimers,
  noPadding,
  tickBank
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const dispatch = useDispatch();

  let copyOptions = options
  let copyUserPrimers = userPrimers

  let [filterOptions, setFilterOptions] = useState(options)
  let [filterUserPrimers, setFilterUserPrimers] = useState(options)
 

  const handleToggleDropdown = () => {
    setIsOpen(true);
    setIsOpen2(false)
    setFilterOptions(copyOptions)
  };
  const handleToggleDropdown2 = () => {
    setIsOpen2(true);
    setIsOpen(false)
    setFilterUserPrimers(copyUserPrimers)
  };

  const handleOptionClick = (option) => {
    onSelect(option);
    setIsOpen(false);
    // tickBank(false)
  };

  const handleOptionClick2 = (option) => {
    onSelect(option);
    setIsOpen2(false);
    tickBank(true)
  };
  


  // console.log("UP2", userPrimers);
  

  

  const handleClearClick = () => {
    // alert('hello '+index+' '+property)
    
    if (index !== undefined && property) {
      // console.log('type 1');
      clearSelect();
    }
    if (index === null && property === undefined) {
      // console.log('type 2');
      clearSelect();
    }
    if (index === undefined && property === undefined) {
      // console.log('type 3');
      clearServiceOption();
    }
    if (index === undefined && property === null) {
      // console.log('type 4'); 
      clearServiceOption();
    }
  };

  const dropdownId = "dropdown-content";
  const dropdownId2 = "dropdown-content";

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (event.target.id !== dropdownId && isOpen) {
        setIsOpen(false); // Close dropdown if clicked outside
      }
      
      if (event.target.id !== dropdownId2 && isOpen2) {
        setIsOpen2(false); // Close dropdown if clicked outside
      }
    };
  
    // Delay the listener to avoid immediate closure after opening
    const timer = setTimeout(() => {
      document.addEventListener("click", handleClickOutside);
    }, 0);
  
    return () => {
      clearTimeout(timer); // Clear timer on cleanup
      document.removeEventListener("click", handleClickOutside);
    };
  }, [setIsOpen, isOpen, setIsOpen2, isOpen2]);


  return (
    <div className='relative'>
      <div className='flex justify-start items-center w-full'>
        <span className={`w-full h-10 inline-flex ${noPadding?'mt-[-1px]':''} items-center`}>
          {selectedOption ? (
            <span className='p-2  w-full'>
              {selectedOption.label || selectedOption}
            </span>
          ) : (
            <span className='p-2  w-full text-gray-500'>
              {/* {property === "library" ? "Library" : "Select option"} */}
              {"Select option"}
            </span>
          )}
          {selectedOption && type !== 2 && (
            <HiOutlineX
              onClick={handleClearClick}
              className='h-7 w-7 mx-2 cursor-pointer '
            />
          )}
          {
          property === 'library' && userPrimers && userPrimers.length > 0 &&
            <span className='group p-2'>
              <div className=' absolute top-2 bottom-2 right-7 bg-gray-300 w-px mx-2' />
              <HiOutlineBookmark
                onClick={handleToggleDropdown2}
                className='h-5 w-5 cursor-pointer '
              />
              <p className='text-sm font-light right-6 top-[-8px] absolute bg-white px-1 hidden group-hover:block pointer-events-none'>
                Primer Bank
              </p>
            </span>
          }
          <span className='group p-2'>
            <div className='absolute top-2 bottom-2 right-7 bg-gray-300 w-px mx-2' />
            <HiOutlineChevronDown
              onClick={handleToggleDropdown}
              className='h-5 w-5 cursor-pointer '
            />
            {property === 'library' &&
              <p className='text-sm font-light right-0 top-[-8px] absolute bg-white px-1 hidden group-hover:block pointer-events-none'>
                  Universal Primers
                </p>
            }
          </span>
        </span>
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            className='origin-top-right absolute right-0 w-full max-h-72 overflow-y-auto rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-10'
          >
            <div className='py-1' id={dropdownId}>
				{property === 'library' || property === 'register' ?
              <>
                <div className="flex relative">
                  <input type="text"
                  id={dropdownId} 
                  autoComplete="off"
                  className="border-1 px-2 mb-2 w-[92%] ml-2  mt-1 h-8"
                  placeholder="Search.."
                  onChange={(e) => {
                    // console.log(e.target.value);
                    setFilterOptions(copyOptions.filter(x => x.label.toLowerCase().includes((e.target.value).toLowerCase())))
                  }}
                  />
                  {/* <HiOutlineX
                  id={dropdownId} 
                    onClick={() => setFilterOptions(copyOptions)}
                    className='h-5 w-5 mx-2 cursor-pointer absolute right-4 top-[10px]'
                  /> */}
                </div>

                {filterOptions.map((option) => (
                  <DropdownOption
                    key={option.label}
                    option={option}
                    handleOptionClick={handleOptionClick}
                  />
                ))}
              </>
              :
              <>
                {options.map((option) => (
                  <DropdownOption
                    key={option.label}
                    option={option}
                    handleOptionClick={handleOptionClick}
                  />
                ))}
              </>}
              
            </div>
          </motion.div>
        )}
        {isOpen2 && (
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            className='origin-top-right absolute right-0 w-full max-h-72 overflow-y-auto rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-10'
          >
            <div className='py-1' id={dropdownId2}>
                <div className="flex relative">
                  <input type="text"
                  id={dropdownId2} 
                  autoComplete="off"
                  className="border-1 px-2 mb-2 w-[92%] ml-2  mt-1 h-8"
                  placeholder="Search.."
                  onChange={(e) => {
                    // console.log(e.target.value);
                    setFilterUserPrimers(copyUserPrimers.filter(x => x.label.toLowerCase().includes((e.target.value).toLowerCase())))
                  }}
                  />
                </div>

              {filterUserPrimers.map((option,i) => (
                <DropdownOption
                  key={i}
                  option={option}
                  handleOptionClick={handleOptionClick2}
                />
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

const DropdownOption = ({ option, handleOptionClick }) => (
  <div
    onClick={() => handleOptionClick(option)}
    className='cursor-pointer px-3 xl:px-4 py-2 flex items-center hover:bg-gray-100 whitespace-nowrap'
  >
    <div className='mr-2'>{option.label}</div>
  </div>
);


export default FormDropdown;
